import React, { useState, useEffect } from "react";
import FilterModal from "../components/comman/FilterModal";
import {
  Button,
  Form,
  InputGroup,
  Table,
  OverlayTrigger,
  Tooltip as BsTooltip,
  Badge,
  Tab,
  Dropdown,
  Spinner,
  Nav,
  Image,
} from "react-bootstrap";
import {
  MdAdd,
  MdSearch,
  MdUpload,
  MdLocalShipping,
  MdDeliveryDining,
  MdSettingsBackupRestore,
  MdFileDownload,
} from "react-icons/md";
import "./index.css";
import { ordersAPI } from "../services/api";
import CustomPagination from "../components/comman/CustomPagination";
import { showToast } from "../services/toast";
import { usePerms } from "../auth/PermissionsProvider";
import { P } from "../auth/permMap";
import CustomAction from "../components/comman/CustomAction";
import PrintModal from "../components/modals/orders/PrintModal";
import ConfirmPayment from "../components/modals/orders/ConfirmPayment";
import PaymentModal from "../components/modals/orders/PaymentModal";
import OrdersMainModal from "../components/modals/orders/OrdersMainModal";
import DispatchListModal from "../components/modals/orders/DispatchListModal";
import DeliveryListModal from "../components/modals/orders/DeliveryListModal";
import { BIG_PAGE_OPTIONS } from "../utils/constants";
import RedispatchListModal from "../components/modals/orders/RedispatchListModal";
import ImageModal from "../components/modals/image-preview/ImageModal";
import ClientListModal from "../components/modals/orders/ClientListModal";
import { useAuth } from "../contexts/AuthContext";
import Loader from "../components/comman/Loader";
const Orders = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // data & loading
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imageModal, setImageModal] = useState({
    open: false,
    image: "",
    alt: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [showImport, setShowImport] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [importReport, setImportReport] = useState(null); // the .data blob
  const [importSuccess, setImportSuccess] = useState(null);
  const [filters, setFilters] = useState({});
  const [filterModalOpen, setFilterModalOpen] = useState(false);

  // New state and handler for Payment Confirmed modal
  const [showPaymentConfirmedModal, setShowPaymentConfirmedModal] =
    useState(false);
  const [selectedOrderForConfirm, setSelectedOrderForConfirm] = useState(null);
  const [remark, setRemark] = useState("");

  const [showPrintModal, setShowPrintModal] = useState(false);
  const [printModal, setPrintModal] = useState({
    order: null,
    remarks: "",
    submitting: false,
  });

  const [showPayModal, setShowPayModal] = useState(false);
  const [payModalData, setPayModalData] = useState({
    order: null,
    file: null,
    mode: "",
    remark: "",
    submitting: false,
  });

  // const [downloadingId, setDownloadingId] = useState(null);
  const [downloadingIds, setDownloadingIds] = useState(new Set());

  const { ready, can } = usePerms();
  const { user } = useAuth();
  const hasRole = (roleName) =>
    user?.roles?.some(
      (role) =>
        role.name?.toLowerCase().trim() === roleName.toLowerCase().trim() ||
        role.slug?.toLowerCase().trim() === roleName.toLowerCase().trim()
    );

  const isSuperAdmin = hasRole("Super Admin");

  console.log("Ready ::");

  // ---- Payment Status (mark Received needs update_payment_status)
  const canMarkPaymentReceived =
    ready &&
    can(P.PAYMENT_UPDATE_STATUS.resource, P.PAYMENT_UPDATE_STATUS.action);

  // ---- Payment Confirm (accounts)
  const canConfirmPayment =
    ready && can(P.PAYMENT_CONFIRM.resource, P.PAYMENT_CONFIRM.action);

  // ---- Client details upload (treat as create/update_client)
  const canUploadClient =
    ready &&
    (can(P.CLIENT_CREATE.resource, P.CLIENT_CREATE.action) ||
      can(P.CLIENT_UPDATE.resource, P.CLIENT_UPDATE.action));

  // ---- Sample Design Ready
  const canSampleDesign =
    ready &&
    can(P.SAMPLE_DESIGN_UPDATE.resource, P.SAMPLE_DESIGN_UPDATE.action);

  // ---- Partner Approval
  const canPartnerApprove =
    ready &&
    can(P.PARTNER_APPROVAL_UPDATE.resource, P.PARTNER_APPROVAL_UPDATE.action);

  // ---- Print Status
  const canUpdatePrint =
    ready && can(P.PRINT_UPDATE_STATUS.resource, P.PRINT_UPDATE_STATUS.action);

  // ---- Generate Print File
  // const canGeneratePrint =
  //   ready && can(P.PRINT_GENERATE_FILE.resource, P.PRINT_GENERATE_FILE.action);

  // ---- Warehouse handover/receive
  const canWHhandover =
    ready && can(P.WH_HANDOVER_UPDATE.resource, P.WH_HANDOVER_UPDATE.action);
  const canWHreceive =
    ready && can(P.WH_RECEIVE_UPDATE.resource, P.WH_RECEIVE_UPDATE.action);

  const canImportDispatch =
    ready && (can("orders", "import_dispatch") || can("orders", "update"));

  // const isEligibleForPrint = (o, hasClientDetails) =>
  //   isPaymentReceived(o?.payment_status) &&
  //   !!o?.payment_confirmed &&
  //   hasClientDetails &&
  //   !!o?.is_sample_design_ready &&
  //   !!o?.is_approved_by_partner;

  const handleFiltersApply = (appliedFilters) => {
    setFilters(appliedFilters);
    setCurrentPage(1);
    // fetchOrders({ ...appliedFilters, page: 1, limit: pageSize });
  };

  //-----------------------------------------------

  //------------------------------------Dispach------------------------//

  const [showDispatchImport, setShowDispatchImport] = useState(false);
  const [dispatchUploading, setDispatchUploading] = useState(false);
  const [dispatchReport, setDispatchReport] = useState(null); // optional error report
  const [dispatchSuccess, setDispatchSuccess] = useState(null);
  //------------------------------------Dispach------------------------//

  useEffect(() => {
    const id = setTimeout(() => setDebouncedSearch(searchTerm.trim()), 300);
    return () => clearTimeout(id);
  }, [searchTerm]);

   const fetchOrders = async (opts = {}) => {
    setLoading(true);
    const { start_date, end_date, ...restFilters } = filters;

    let startDateTime, endDateTime;

    if (start_date) {
      const s = new Date(start_date);
      s.setHours(0, 0, 0, 0);
      startDateTime = s.toISOString();
    }

    if (end_date) {
      const e = new Date(end_date);
      e.setHours(23, 59, 59, 999);
      endDateTime = e.toISOString();
    }
    try {
      const params = {
        page: opts.page ?? currentPage,
        limit: opts.limit ?? pageSize,
        search: opts.search ?? debouncedSearch,
        start_date: startDateTime,
        end_date: endDateTime,
        ...restFilters,
      };

      const res = await ordersAPI.getOrders(params);

      if (res?.isSuccess || res?.status === 200) {
        const list = res.data?.orders ?? res.data?.orderList ?? [];
        const pg = res.data?.pagination ?? {};

        setOrders(Array.isArray(list) ? list : []);
        setTotal(pg.total || 0);
        setTotalPages(pg.totalPages || 1);
        setCurrentPage(pg.page || 1);
        setPageSize(pg.limit || pageSize);
      } else {
        showToast("error", res?.message || "Failed to load orders");
      }
    } catch (err) {
      showToast("error", "Failed to load orders");
    } finally {
      setLoading(false);
    }
  };

  const fetchOrdersWithFilters = (extra = {}) => {
    fetchOrders({ ...filters, ...extra });
  };

  // // Initial + react to page/size/search changes
  // useEffect(() => {
  //   fetchOrders({
  //     page: currentPage,
  //     limit: pageSize,
  //     search: debouncedSearch,
  //   });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentPage, pageSize, debouncedSearch /*, statusFilter*/]);

  useEffect(() => {
    fetchOrders({
      ...filters, // always include applied filters
      page: currentPage,
      limit: pageSize,
      search: debouncedSearch,
    });
  }, [currentPage, pageSize, debouncedSearch, filters]);

  const getPaymentVariant = (status) => {
    switch ((status || "").toLowerCase()) {
      case "received":
        return "success";
      case "pending":
      default:
        return "warning";
    }
  };

  const getStatusVariant = (status) => {
    switch ((status || "").toLowerCase()) {
      case "completed":
        return "success";
      case "processing":
        return "warning";
      case "pending":
        return "info";
      case "cancelled":
        return "secondary";
      default:
        return "secondary";
    }
  };

  const onImportFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const res = await ordersAPI.importOrders(file); // should return res.data on 2xx
      console.log("Response :::: ", res);

      if (res?.isSuccess) {
        // toast.success(res?.message || "Orders imported successfully");
        // setImportReport(res.data); // { totalRows, createdCount, updatedCount, errorCount, created, updated, errors }
        // setImportSuccess(true);

        if (res?.data?.errors && res.data.errors.length > 0) {
          setImportReport(res?.data); // Set the import error report
          setImportSuccess(false); // Mark as failed import
          setShowImport(true); // Show the import report modal
          // toast.error("Import failed due to validation errors");
          showToast("error", "Import failed due to validation errors");
        } else {
          // toast.success("Partners imported successfully");
          showToast("success", "Orders imported successfully");
          setImportReport(null); // Reset the report
          setImportSuccess(null); // Reset the import success state
          setShowImport(false); // Close the modal on successful import
          await fetchOrders({
            page: currentPage,
            limit: pageSize,
            search: debouncedSearch,
          });
        }
      } else {
        // non-2xx but still resolved (rare) – treat as error report if provided
        // setImportReport(res?.data || null);
        // setImportSuccess(false);
        // toast.error(res?.message || "Import failed");
        showToast("error", res.message || "Import failed!");
        setImportReport(res?.data || null); // Set the error report
        setImportSuccess(false);
      }
    } catch (err) {
      // Axios throws on 4xx – your payload is in err.response.data
      const payload = err?.response?.data;
      if (payload?.data?.errors) {
        // Your exact 400 shape
        setImportReport(payload.data); // { totalRows, validRows, errorRows, errors:[{row, errors:[...], data:{...}}] }
        setImportSuccess(false);
        // toast.error(
        //   payload?.message || "Excel file contains validation errors"
        // );
        showToast("error", payload?.message || "Import failed!");
      } else {
        setImportReport(null);
        setImportSuccess(null);
        setShowImport(false);
        // toast.error(payload?.message || "Import failed");
        showToast("error", payload?.message || "Import failed!");
      }
    } finally {
      setUploading(false);
      if (e?.target) e.target.value = ""; // allow re-select same file
    }
  };

  // Actions (wire later)
  // const onView = (o) => {
  //   /* open modal or navigate */
  // };
  // const onEdit = (o) => {
  //   /* open edit modal */
  // };
  // const onDelete = async (o) => {
  //   /* call ordersAPI.deleteOrder(o.id); then fetchOrders() and handle last-item-on-page case */
  // };

  const downloadValidationErrorsCsv = (report) => {
    if (!report?.errors?.length) return;

    // Collect all data keys across error rows
    const dataKeys = Array.from(
      report.errors.reduce((set, r) => {
        Object.keys(r.data || {}).forEach((k) => set.add(k));
        return set;
      }, new Set())
    );

    const header = ["row", "errors", ...dataKeys].join(",");
    const lines = report.errors.map((r) => {
      const errMsg = (r.errors || []).join("; ");
      const cells = dataKeys.map((k) => {
        let v = r.data?.[k];
        if (v === null || v === undefined) v = "";
        v = String(v).replace(/"/g, '""');
        return `"${v}"`;
      });
      return [`"${r.row}"`, `"${errMsg.replace(/"/g, '""')}"`, ...cells].join(
        ","
      );
    });

    const csv = [header, ...lines].join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `order-import-validation-errors-${Date.now()}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleClientDetailsUpload = async (order, file) => {
    if (!file) return;

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("order_id", order.id);

      setOrders((prev) =>
        prev.map((row) =>
          row.id === order.id
            ? { ...row, isUploading: true } // set uploading state for the current row
            : row
        )
      );

      // ✅ Replace with your actual API endpoint
      const response = await ordersAPI.uploadClientDetails(order.id, file);

      console.log("Response ::; ", response);

      if (response.isSuccess) {
        // toast.success("Client details uploaded successfully ✅");
        showToast("success", "Client details uploaded successfully!");
        setOrders((prev) =>
          prev.map((row) =>
            row.id === order.id
              ? { ...row, isUploading: false } // hide loader after successful upload
              : row
          )
        );
        // Optionally refresh your orders list
        await fetchOrders({
          page: currentPage,
          limit: pageSize,
          search: debouncedSearch,
        });
      } else {
        // toast.error(response.data.message || "Upload failed");
        showToast("error", response.message || "Upload failed!");
        setOrders((prev) =>
          prev.map((row) =>
            row.id === order.id
              ? { ...row, isUploading: false } // hide loader after failure
              : row
          )
        );
        setImportReport(response.data); // handle errors
        setShowImport(true);
      }
    } catch (error) {
      console.error("Upload error:", error);
      showToast(
        "error",
        error?.response?.data?.message ||
          "Something went wrong while uploading ❌"
      );
      setOrders((prev) =>
        prev.map((row) =>
          row.id === order.id
            ? { ...row, isUploading: false } // hide loader after failure
            : row
        )
      );
    }
  };

  const openPaymentModal = (order) => {
    setPayModalData({
      order,
      file: null,
      mode: "",
      remark: "",
      submitting: false,
    });
    setShowPayModal(true);
  };

  const closePaymentModal = () => {
    setShowPayModal(false);
    setPayModalData((d) => ({ ...d, submitting: false }));
  };

  const handlePaymentStatusChange = async (order, nextStatus) => {
    const current = order.payment_status || "Pending";
    if (
      (order.payment_status || "Pending") === "Pending" &&
      nextStatus === "Received"
    ) {
      openPaymentModal(order);
      return;
    }
    // fallback: direct update (Pending)
    if (current === "Received" && nextStatus === "Pending") {
      showToast("error", "Cannot revert to Pending after marking as Received");
      return;
    }
  };

  const submitPaymentModal = async () => {
    const { order, file, mode, remark } = payModalData;
    if (!file)
      return showToast("error", "Please upload the payment proof image");
    if (!mode) return showToast("error", "Please select a payment mode");
    // if (!remark.trim()) return showToast("error", "Please enter a remark");

    try {
      setPayModalData((d) => ({ ...d, submitting: true }));

      let { data } = await ordersAPI.updatePaymentStatusWithProof(order.id, {
        status: "Received",
        file,
        mode,
        remark,
      });

      console.log("REsponse ::: ", data);

      // update UI
      setOrders((prev) =>
        prev.map((row) =>
          row.id === order.id
            ? {
                ...row,
                payment_status: "Received",
                payment_mode: data?.payment_mode,
                payment_received_date: data?.payment_received_date,
                payment_snapshots: data?.payment_snapshots,
                sales_payment_remarks: data?.sales_payment_remarks,

                // you can also store proof url/mode/remark if API returns it
              }
            : row
        )
      );

      showToast("success", "Payment marked as Received");
      closePaymentModal();
    } catch (err) {
      console.error(err);
      showToast("error", "Failed to submit payment details");
      setPayModalData((d) => ({ ...d, submitting: false }));
    }
  };

  const openPaymentConfirmedModal = (order) => {
    setSelectedOrderForConfirm(order);
    setRemark("");
    setShowPaymentConfirmedModal(true);
  };

  const closePaymentConfirmedModal = () => {
    setShowPaymentConfirmedModal(false);
    setSelectedOrderForConfirm(null);
  };

  const handlePaymentConfirmedChange = async (order, status) => {
    if (status === "Confirmed") {
      openPaymentConfirmedModal(order);
    } else {
      showToast("error", "Cannot revert to Pending after marking as Confirmed");
    }
  };

  // Submit confirmation after adding a remark
  const submitPaymentConfirmed = async () => {
    // if (!remark.trim()) {
    //   return showToast("error", "Please add a remark");
    // }

    try {
      let { data } = await ordersAPI.updatePaymentConfirmed(
        selectedOrderForConfirm.id,
        {
          status: "Confirmed",
          remark,
        }
      );
      setOrders((prev) =>
        prev.map((row) =>
          row.id === selectedOrderForConfirm.id
            ? {
                ...row,
                payment_confirmed: true,
                payment_confirmation_date: data?.payment_confirmation_date,
                account_payment_remarks: data?.account_payment_remarks,
                // remark
              } // Add the confirmed status and remark
            : row
        )
      );
      showToast("success", "Payment confirmed");
      closePaymentConfirmedModal();
    } catch (error) {
      console.error(error);

      showToast(
        "error",
        error?.response?.data?.message || "Failed to confirm payment"
      );
    }
  };

  const handleSampleDesignReadyChange = async (order, nextValue) => {
    const prev = !!order.is_sample_design_ready;

    // no-op if same
    if (prev === nextValue) return;

    // optimistic UI
    setOrders((rows) =>
      rows.map((r) =>
        r.id === order.id ? { ...r, is_sample_design_ready: nextValue } : r
      )
    );

    try {
      await ordersAPI.updateSampleDesignReady(order.id, nextValue);
      showToast(
        "success",
        nextValue ? "Marked Sample Design as READY" : "Marked as NOT READY"
      );
    } catch (err) {
      console.error(err);
      // rollback
      setOrders((rows) =>
        rows.map((r) =>
          r.id === order.id ? { ...r, is_sample_design_ready: prev } : r
        )
      );
      showToast(
        "error",
        err?.response?.data?.message || "Failed to update Sample Design Ready"
      );
    }
  };

  const handleApprovedByPartnerChange = async (order, nextVal) => {
    const prev = !!order.is_approved_by_partner;
    if (prev === nextVal) return;

    // optimistic UI
    setOrders((rows) =>
      rows.map((r) =>
        r.id === order.id ? { ...r, is_approved_by_partner: nextVal } : r
      )
    );

    try {
      await ordersAPI.updateApprovedByPartner(order.id, nextVal);
      showToast(
        "success",
        nextVal ? "Approved by partner" : "Marked as not approved"
      );
    } catch (err) {
      console.error(err);
      // rollback
      setOrders((rows) =>
        rows.map((r) =>
          r.id === order.id ? { ...r, is_approved_by_partner: prev } : r
        )
      );
      showToast(
        "error",
        err?.response?.data?.message || "Failed to update partner approval"
      );
    }
  };

  const getYesNoVariant = (val) => (val ? "success" : "secondary");

  const getPrintVariant = (status) =>
    (status || "").toLowerCase() === "done" ? "success" : "warning";

  const openPrintModal = (order) => {
    setPrintModal({ order, remarks: "", submitting: false });
    setShowPrintModal(true);
  };

  const closePrintModal = () => {
    setShowPrintModal(false);
    setPrintModal((d) => ({ ...d, submitting: false }));
  };

  // dropdown handler from the table
  const handlePrintStatusChange = async (order, nextStatus) => {
    const current = order.print_status || "Pending";
    if (current === nextStatus) return;

    // If moving to Done -> ask remarks
    if (nextStatus === "Done") {
      openPrintModal(order);
      return;
    }

    // Else (set to Pending) -> update directly
    const prev = order;
    // optimistic
    setOrders((rows) =>
      rows.map((r) =>
        r.id === order.id
          ? {
              ...r,
              print_status: "Pending",
              print_remarks: null,
              print_file_date: null,
            }
          : r
      )
    );
    try {
      await ordersAPI.updatePrintStatus(order.id, {
        status: "Pending",
        remarks: null,
        printFileDate: null,
      });
      showToast("success", "Print status set to Pending");
    } catch (e) {
      // rollback
      setOrders((rows) =>
        rows.map((r) =>
          r.id === order.id
            ? {
                ...r,
                print_status: prev?.print_status,
                print_remarks: prev?.print_remarks,
                print_file_date: prev?.print_file_date,
              }
            : r
        )
      );
      console.error(e);
      showToast(
        "error",
        e?.response?.data?.message || "Failed to update print status!"
      );
    }
  };

  // submit modal (for Done)
  const submitPrintModal = async () => {
    const { order, remarks } = printModal;
    // if (!remarks.trim()) {
    //   return showToast("error", "Please enter print remarks");
    // }

    try {
      setPrintModal((d) => ({ ...d, submitting: true }));

      const printFileDate = new Date().toISOString(); // set now; adjust if you later add a date picker
      await ordersAPI.updatePrintStatus(order.id, {
        status: "Done",
        remarks: remarks.trim(),
        printFileDate,
      });

      // optimistic -> confirmed
      setOrders((rows) =>
        rows.map((r) =>
          r.id === order.id
            ? {
                ...r,
                print_status: "Done",
                print_remarks: remarks.trim(),
                print_file_date: printFileDate,
              }
            : r
        )
      );

      showToast("success", "Print marked as Done");
      closePrintModal();
    } catch (e) {
      console.error(e);
      showToast(
        "error",
        e?.response?.data?.message || "Failed to save print status"
      );
      setPrintModal((d) => ({ ...d, submitting: false }));
    }
  };

  const isPaymentReceived = (status) =>
    ["received", "recieved"].includes((status || "").toLowerCase());

  // build reasons for disabling tooltip
  const getMissingReasons = (o, hasClientDetails) => {
    const reasons = [];
    if (!isPaymentReceived(o?.payment_status))
      reasons.push("Payment status must be Received");
    if (!o?.payment_confirmed) reasons.push("Payment must be confirmed");
    if (!hasClientDetails) reasons.push("Client details must be uploaded");
    if (!o?.is_sample_design_ready) reasons.push("Sample design must be ready");
    if (!o?.is_approved_by_partner)
      reasons.push("Partner approval is required");
    return reasons;
  };

  const handleDownloadPrintFile = async (order) => {
    try {
      const res = await ordersAPI.downloadPrintFile(order.id);

      // res might be: ArrayBuffer  |  Blob  |  { data: ArrayBuffer|Blob, headers: ... }
      const payload = res && res.data !== undefined ? res.data : res;
      console.log("Download response:", res);
      console.log(
        "Payload type:",
        typeof payload,
        payload instanceof Blob,
        payload instanceof ArrayBuffer
      );

      let blob;
      if (payload instanceof Blob) {
        blob = payload;
      } else if (payload instanceof ArrayBuffer) {
        blob = new Blob([payload], { type: "application/pdf" });
      } else {
        throw new Error(
          "Unexpected download response type (not Blob/ArrayBuffer)"
        );
      }

      // Optional sanity check: PDF starts with %PDF
      const head = await blob
        .slice(0, 4)
        .text()
        .catch(() => "");
      if (head !== "%PDF") {
        const txt = await blob.text().catch(() => "");
        throw new Error(txt || "Downloaded content is not a valid PDF");
      }

      // If you don't have headers (because interceptors stripped them), just use a fallback name
      const filename = `sleeves_${order.order_no ?? order.id}.pdf`;

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      showToast("error", err.message || "Failed to download print file");
    }
  };

  const handleSleeveHandoverChange = async (order, nextStatus) => {
    const nextVal = nextStatus === "Sent";
    const prevVal = !!order.is_sleeve_handover_to_warehouse;
    if (prevVal === nextVal) return;

    // optimistic
    setOrders((rows) =>
      rows.map((r) =>
        r.id === order.id
          ? { ...r, is_sleeve_handover_to_warehouse: nextVal }
          : r
      )
    );

    try {
      let { data } = await ordersAPI.updateSleeveHandoverToWarehouse(
        order.id,
        nextVal
      );
      setOrders((rows) =>
        rows.map((r) =>
          r.id === order.id
            ? {
                ...r,
                is_sleeve_handover_to_warehouse: nextVal,
                sleeve_handover_date: data?.sleeve_handover_date,
              }
            : r
        )
      );
      showToast(
        "success",
        nextVal ? "Sleeves marked as Sent to warehouse" : "Marked as Pending"
      );
    } catch (e) {
      // rollback
      setOrders((rows) =>
        rows.map((r) =>
          r.id === order.id
            ? { ...r, is_sleeve_handover_to_warehouse: prevVal }
            : r
        )
      );
      console.error(e);
      showToast(
        "error",
        e?.response?.data?.message || "Failed to update sleeve handover status"
      );
    }
  };

  // helper for button color (optional)
  const getPendingSentVariant = (status) =>
    (status || "").toLowerCase() === "sent" ? "success" : "warning";

  const handleSleeveReceivedChange = async (order, nextStatus) => {
    const nextVal = nextStatus === "Received";
    const prevVal = !!order.is_sleeve_received_to_warehouse;
    if (prevVal === nextVal) return;

    // (optional) guard: block "Received" until "Sent" is true
    // if (nextVal && !order.is_sleeve_handover_to_warehouse) {
    //   return toast.error("Cannot mark Received before it is Sent to warehouse");
    // }

    // optimistic update
    setOrders((rows) =>
      rows.map((r) =>
        r.id === order.id
          ? { ...r, is_sleeve_received_to_warehouse: nextVal }
          : r
      )
    );

    try {
      let { data } = await ordersAPI.updateSleeveReceivedToWarehouse(
        order.id,
        nextVal
      );
      setOrders((rows) =>
        rows.map((r) =>
          r.id === order.id
            ? {
                ...r,
                is_sleeve_received_to_warehouse: nextVal,
                sleeve_received_date: data?.sleeve_received_date,
              }
            : r
        )
      );
      showToast(
        "success",
        nextVal ? "Sleeves marked as Received" : "Marked as Pending"
      );
    } catch (e) {
      // rollback
      setOrders((rows) =>
        rows.map((r) =>
          r.id === order.id
            ? { ...r, is_sleeve_received_to_warehouse: prevVal }
            : r
        )
      );
      console.error(e);
      showToast("error", "Failed to update sleeve receive status");
    }
  };

  const getPendingReceivedVariant = (label) =>
    (label || "").toLowerCase() === "received" ? "success" : "warning";

  //------------------------------------Dispach------------------------//

  const [showDispatchModal, setShowDispatchModal] = useState(false);
  const [dispatchOrder, setDispatchOrder] = useState(null);
  const [dispatchLoading, setDispatchLoading] = useState(false);
  const [dispatchList, setDispatchList] = useState([]);
  const [dispatchPage, setDispatchPage] = useState(1);
  const [dispatchPageSize] = useState(10);
  const [dispatchTotal, setDispatchTotal] = useState(0);
  const [dispatchTotalPages, setDispatchTotalPages] = useState(1);

  const fetchDispatches = async (
    orderId,
    page = 1,
    limit = dispatchPageSize
  ) => {
    setDispatchLoading(true);
    try {
      const res = await ordersAPI.getDispatches(orderId, { page, limit });

      console.log("Response ::: ", res);

      const list = res?.dispatches ?? res?.data?.rows ?? res?.data ?? [];

      const pg = res?.pagination ?? {
        page,
        limit,
        total: Array.isArray(list) ? list.length : 0,
        totalPages: 1,
      };

      setDispatchList(Array.isArray(list) ? list : []);
      setDispatchPage(pg.page || page);
      setDispatchTotal(pg.total || 0);
      setDispatchTotalPages(pg.totalPages || 1);
    } catch (e) {
      showToast("error", "Failed to load dispatches");
      setDispatchList([]);
      setDispatchPage(1);
      setDispatchTotal(0);
      setDispatchTotalPages(1);
    } finally {
      setDispatchLoading(false);
    }
  };

  const onDispatchFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setDispatchUploading(true);
    try {
      const res = await ordersAPI.importDispatch(file); // add this API if not already
      if (res?.isSuccess) {
        if (res?.data?.errors?.length) {
          setDispatchReport(res.data);
          setDispatchSuccess(false);
          showToast("error", "Dispatch import has validation errors");
        } else {
          setDispatchReport(res.data || null);
          setDispatchSuccess(true);
          showToast("success", "Dispatch data imported successfully");
          setShowDispatchImport(false);
          await fetchOrders({
            page: currentPage,
            limit: pageSize,
            search: debouncedSearch,
          });
        }
      } else {
        setDispatchReport(res?.data || null);
        setDispatchSuccess(false);
        showToast("error", res?.message || "Dispatch import failed");
      }
    } catch (err) {
      const payload = err?.response?.data;
      if (payload?.data?.errors) {
        setDispatchReport(payload.data);
        setDispatchSuccess(false);
        showToast("error", payload?.message || "Dispatch import failed");
      } else {
        setDispatchReport(null);
        setDispatchSuccess(null);
        setShowDispatchImport(false);
        showToast("error", payload?.message || "Dispatch import failed");
      }
    } finally {
      setDispatchUploading(false);
      if (e?.target) e.target.value = "";
    }
  };

  // const downloadDispatchErrorsCsv = (report) => {
  //   if (!report?.errors?.length) return;

  //   const dataKeys = Array.from(
  //     report.errors.reduce((set, r) => {
  //       Object.keys(r.data || {}).forEach((k) => set.add(k));
  //       return set;
  //     }, new Set())
  //   );

  //   const header = ["row", "errors", ...dataKeys].join(",");
  //   const lines = report.errors.map((r) => {
  //     const errMsg = (r.errors || []).join("; ");
  //     const cells = dataKeys.map((k) => {
  //       let v = r.data?.[k];
  //       if (v === null || v === undefined) v = "";
  //       v = String(v).replace(/"/g, '""');
  //       return `"${v}"`;
  //     });
  //     return [`"${r.row}"`, `"${errMsg.replace(/"/g, '""')}"`, ...cells].join(
  //       ","
  //     );
  //   });

  //   const csv = [header, ...lines].join("\n");
  //   const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  //   const url = URL.createObjectURL(blob);
  //   const a = document.createElement("a");
  //   a.href = url;
  //   a.download = `dispatch-import-errors-${Date.now()}.csv`;
  //   a.click();
  //   URL.revokeObjectURL(url);
  // };

  const openDispatchModal = async (order) => {
    setDispatchOrder(order);
    setShowDispatchModal(true);
    await fetchDispatches(order.id, 1, dispatchPageSize);
  };

  const closeDispatchModal = () => {
    setShowDispatchModal(false);
    setDispatchOrder(null);
    setDispatchList([]);
    setDispatchPage(1);
    setDispatchTotal(0);
    setDispatchTotalPages(1);
  };

  const handleDispatchPageChange = (p) => {
    if (!dispatchOrder) return;
    setDispatchPage(p);
    fetchDispatches(dispatchOrder.id, p, dispatchPageSize);
  };

  //------------------------------------Dispach------------------------//

  //==============================Import Delivery=======================//
  // Orders.jsx
  const [showDeliveryImport, setShowDeliveryImport] = useState(false);
  const [deliveryImportReport, setDeliveryImportReport] = useState(null);
  const [deliveryImportSuccess, setDeliveryImportSuccess] = useState(null);
  const [deliveryUploading, setDeliveryUploading] = useState(false);
  // const [deliveryImportOrder, setDeliveryImportOrder] = useState(null);

  // const openDeliveryImport = (order) => {
  //   setDeliveryImportOrder(order);
  //   setDeliveryImportReport(null);
  //   setDeliveryImportSuccess(null);
  //   setShowDeliveryImport(true);
  // };

  const onDeliveryImportFileChange = async (e) => {
    const file = e.target.files?.[0];

    console.log("File");

    if (!file) return;
    setDeliveryUploading(true);
    try {
      const res = await ordersAPI.importDeliveryData(file);

      console.log("Res fff :: ", res);

      // Expecting { isSuccess, data, message }
      if (res?.isSuccess) {
        console.log("Res ::: ", res);

        if (res?.data?.errors?.length) {
          setDeliveryImportReport(res.data);
          setDeliveryImportSuccess(false);
          // show a toast if you want
          showToast("error", "Import failed due to validation errors");
        } else {
          // success
          showToast("success", "Delivery data imported successfully");
          setShowDeliveryImport(false);
          setDeliveryImportReport(res.data);
          setDeliveryImportSuccess(true);
          // refresh list
          await fetchOrders({
            page: currentPage,
            limit: pageSize,
            search: debouncedSearch,
          });
        }
      } else {
        // API returned a failure shape
        setDeliveryImportReport(res?.data || null);
        setDeliveryImportSuccess(false);
        showToast("error", res?.message || "Import failed");
      }
    } catch (err) {
      const payload = err?.response?.data;
      if (payload?.data?.errors) {
        setDeliveryImportReport(payload.data);
        setDeliveryImportSuccess(false);
        showToast("error", payload?.message || "Import failed");
      } else {
        setDeliveryImportReport(null);
        setDeliveryImportSuccess(null);
        setShowDeliveryImport(false);
        showToast("error", payload?.message || "Import failed");
      }
    } finally {
      setDeliveryUploading(false);
      if (e?.target) e.target.value = "";
    }
  };

  //==============================Import Delivery=======================//

  //------------------------------------Dilevery-----------------------//
  const [showDeliveryModal, setShowDeliveryModal] = useState(false);
  const [deliveryOrder, setDeliveryOrder] = useState(null);
  const [deliveryLoading, setDeliveryLoading] = useState(false);
  const [deliveryList, setDeliveryList] = useState([]);
  const [deliveryPage, setDeliveryPage] = useState(1);
  const [deliveryPageSize] = useState(10);
  const [deliveryTotal, setDeliveryTotal] = useState(0);
  const [deliveryTotalPages, setDeliveryTotalPages] = useState(1);

  const fetchDeliveries = async (
    orderId,
    page = 1,
    limit = deliveryPageSize
  ) => {
    setDeliveryLoading(true);
    try {
      const res = await ordersAPI.getDeliveries(orderId, { page, limit });
      const list = res?.deliveries ?? res?.data ?? [];
      const pg = res?.pagination ?? {
        page,
        limit,
        total: Array.isArray(list) ? list.length : 0,
        totalPages: 1,
      };
      setDeliveryList(Array.isArray(list) ? list : []);
      setDeliveryPage(pg.page || page);
      setDeliveryTotal(pg.total || 0);
      setDeliveryTotalPages(pg.totalPages || 1);

      // update the order row with delivered count so the column shows immediately next time
      const deliveredCount = res?.totals?.total_delivered ?? 0;
      setOrders((rows) =>
        rows.map((r) =>
          r.id === orderId ? { ...r, delivered_count: deliveredCount } : r
        )
      );
    } catch (e) {
      showToast("error", "Failed to load deliveries");
      setDeliveryList([]);
      setDeliveryPage(1);
      setDeliveryTotal(0);
      setDeliveryTotalPages(1);
    } finally {
      setDeliveryLoading(false);
    }
  };

  const openDeliveryModal = async (order) => {
    setDeliveryOrder(order);
    setShowDeliveryModal(true);
    await fetchDeliveries(order.id, 1, deliveryPageSize);
  };

  const closeDeliveryModal = () => {
    setShowDeliveryModal(false);
    setDeliveryOrder(null);
    setDeliveryList([]);
    setDeliveryPage(1);
    setDeliveryTotal(0);
    setDeliveryTotalPages(1);
  };

  const handleDeliveryPageChange = (p) => {
    if (!deliveryOrder) return;
    setDeliveryPage(p);
    fetchDeliveries(deliveryOrder.id, p, deliveryPageSize);
  };

  //------------------------------------Dilevery-----------------------//

  //=========================== RE Dispatch ===========================//
  const [showRedispatchImport, setShowRedispatchImport] = useState(false);
  const [redispatchImportReport, setRedispatchImportReport] = useState(null);
  const [redispatchImportSuccess, setRedispatchImportSuccess] = useState(null);
  const [redispatchUploading, setRedispatchUploading] = useState(false);

  const onRedispatchImportFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setRedispatchUploading(true);
    try {
      // ⬇️ implement this endpoint in your `ordersAPI`
      const res = await ordersAPI.importRedispatchData(file);

      if (res?.isSuccess) {
        if (res?.data?.errors?.length) {
          setRedispatchImportReport(res.data);
          setRedispatchImportSuccess(false);
          showToast("error", "Redispatch import has validation errors");
        } else {
          showToast("success", "Redispatch data imported successfully");
          setShowRedispatchImport(false);
          setRedispatchImportReport(res.data || null);
          setRedispatchImportSuccess(true);
          await fetchOrders({
            page: currentPage,
            limit: pageSize,
            search: debouncedSearch,
          });
        }
      } else {
        setRedispatchImportReport(res?.data || null);
        setRedispatchImportSuccess(false);
        showToast("error", res?.message || "Redispatch import failed");
      }
    } catch (err) {
      const payload = err?.response?.data;
      if (payload?.data?.errors) {
        setRedispatchImportReport(payload.data);
        setRedispatchImportSuccess(false);
        showToast("error", payload?.message || "Redispatch import failed");
      } else {
        setRedispatchImportReport(null);
        setRedispatchImportSuccess(null);
        setShowRedispatchImport(false);
        showToast("error", payload?.message || "Redispatch import failed");
      }
    } finally {
      setRedispatchUploading(false);
      if (e?.target) e.target.value = "";
    }
  };

  // --- Redispatch list modal state ---
  const [showRedispatchModal, setShowRedispatchModal] = useState(false);
  const [redispatchOrder, setRedispatchOrder] = useState(null);
  const [redispatchLoading, setRedispatchLoading] = useState(false);
  const [redispatchList, setRedispatchList] = useState([]);
  const [redispatchPage, setRedispatchPage] = useState(1);
  const [redispatchPageSize] = useState(10);
  const [redispatchTotal, setRedispatchTotal] = useState(0);
  const [redispatchTotalPages, setRedispatchTotalPages] = useState(1);

  const fetchRedispatches = async (
    orderId,
    page = 1,
    limit = redispatchPageSize
  ) => {
    setRedispatchLoading(true);
    try {
      const res = await ordersAPI.getRedispatches(orderId, { page, limit });
      const list = res?.dispatches ?? res?.data?.rows ?? res?.data ?? [];
      const pg = res?.pagination ?? {
        page,
        limit,
        total: Array.isArray(list) ? list.length : 0,
        totalPages: 1,
      };

      setRedispatchList(Array.isArray(list) ? list : []);
      setRedispatchPage(pg.page || page);
      setRedispatchTotal(pg.total || 0);
      setRedispatchTotalPages(pg.totalPages || 1);

      // reflect latest count into the order row so the table shows immediately next time
      const count =
        res?.totals?.total_redispatches ??
        res?.total_redispatches ??
        pg.total ??
        0;
      setOrders((rows) =>
        rows.map((r) =>
          r.id === orderId ? { ...r, redispatch_count: count } : r
        )
      );
    } catch (e) {
      showToast("error", "Failed to load redispatches");
      setRedispatchList([]);
      setRedispatchPage(1);
      setRedispatchTotal(0);
      setRedispatchTotalPages(1);
    } finally {
      setRedispatchLoading(false);
    }
  };

  const openRedispatchModal = async (order) => {
    setRedispatchOrder(order);
    setShowRedispatchModal(true);
    await fetchRedispatches(order.id, 1, redispatchPageSize);
  };

  const closeRedispatchModal = () => {
    setShowRedispatchModal(false);
    setRedispatchOrder(null);
    setRedispatchList([]);
    setRedispatchPage(1);
    setRedispatchTotal(0);
    setRedispatchTotalPages(1);
  };

  const handleRedispatchPageChange = (p) => {
    if (!redispatchOrder) return;
    setRedispatchPage(p);
    fetchRedispatches(redispatchOrder.id, p, redispatchPageSize);
  };

  //=========================== RE Dispatch ===========================//
  //============================== Client List=======================//

  //------------------------------------client-----------------------//
  const [showClientListModal, setShowClientListModal] = useState(false);
  const [clientOrder, setClientOrder] = useState(null);
  const [clientList, setClientList] = useState(null);

  const openClientList = async (client) => {
    console.log("uksafdiu", client);
    setClientList(client?.clients);
    setClientOrder(client?.order_no);

    setShowClientListModal(true);
  };

  const closeClientListModal = () => {
    setShowClientListModal(false);
  };

  //=========================== Export Orders ===========================//
  const handleExportOrders = async () => {
    try {
      const blob = await ordersAPI.exportOrders({});
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "orders.xlsx");
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export error:", error);
      alert("Export failed!");
    }
  };

  return (
    <>
      {/* <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Orders Management</h4>
        <div className="d-flex gap-2">
          <Button
            variant="primary"
            className="d-flex gap-1 align-items-center"
            onClick={() => setShowImport(true)}
          >
            Upload Orders
          </Button>

          <Button variant="primary" className="d-flex gap-1 align-items-center">
            <MdAdd /> Add Order
          </Button>
        </div>
      </div> */}
      {/* <div className="h-100 overflow-auto">  */}

      <div className="d-flex justify-content-between align-items-center mb-3 sticky-to p-3 bg-body shadow-sm">
        <h4 className="mb-0">Orders</h4>
        <div className="d-flex flex-end gap-2">
          <InputGroup className="search-bar border-primary rounded-2">
            <Form.Control
              placeholder="Search orders..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <InputGroup.Text className="cursor-pointer">
              <MdSearch />
            </InputGroup.Text>
          </InputGroup>
          <CustomAction
            actions={[
              {
                label: "Upload Orders",
                icon: MdUpload,
                onClick: () => setShowImport(true),
              },
              {
                label: "Upload Dispatch Data",
                icon: MdLocalShipping,
                onClick: () => setShowDispatchImport(true),
                hidden: !canImportDispatch, // if CustomAction respects hidden
                // or omit this item entirely if not allowed
              },
              {
                label: "Upload Delivery Data",
                icon: MdDeliveryDining,
                onClick: () => setShowDeliveryImport(true),
                // hidden: !canImportDelivery, // gate by perms
              },
              {
                label: "Upload Redispatch Data",
                icon: MdSettingsBackupRestore,
                onClick: () => setShowRedispatchImport(true),
                // hidden: !canImportRedispatch,
              },
              {
                label: "Export Orders",
                icon: MdFileDownload,
                onClick: () => {
                  handleExportOrders(true);
                },
              },
              {
                label: "Add Order",
                icon: MdAdd,
              },
            ]}
          />

          <Button variant="primary" onClick={() => setFilterModalOpen(true)}>
            Filters
          </Button>
        </div>
      </div>

      <div className="px-3 position-relative h-100">
        <Tab.Container id="tabs" defaultActiveKey="home" transition={false}>
          <Nav
            variant="pills"
            className="mb-3 d-flex gap-2 sticky-tp border-bottom bg-body"
          >
            <Nav.Item>
              <Nav.Link eventKey="home">All</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="profile">Pending</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="contact">Completed</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content className="table-tab-content ">
            <Tab.Pane eventKey="home" className="h-100">
              <div className=" table-cover tab-table-cover overflow-auto order-module-table">
                {loading && (
                  <div
                    className="text-center py-3 h-100 d-flex align-items-center justify-content-center"
                    // style={{ background: "rgba(255,255,255,0.6)", zIndex: 2 }}
                  >
                    <Spinner animation="border" />
                  </div>
                )}

                <Table hover bordered className="position-relative">
                  <thead className="sticky-top">
                    <tr>
                      <th>Order</th>
                      <th>Created At</th>
                      <th>Amount</th>
                      <th className="text-nowrap" style={{ minWidth: "100px" }}>
                        Order Date
                      </th>
                      <th>Partner Code</th>
                      <th style={{ minWidth: "120px" }}>Partner Name</th>
                      <th>With Sleeve</th>
                      <th>Partner Details</th>
                      <th>Client Name</th>
                      <th>Box</th>
                      <th>Sleeve Name</th>
                      <th>Occasion Month</th>
                      <th>Qty</th>
                      <th>Partner Address Delivery-Qty</th>
                      <th>Client Address Delivery-Qty</th>
                      <th style={{ minWidth: "100px" }}>BDM</th>
                      <th style={{ minWidth: "120px" }}>Client Details</th>
                      <th style={{ minWidth: "100px" }}>
                        Client Details Receive Date
                      </th>
                      <th>Payment Status</th>
                      <th style={{ minWidth: "100px" }}>Payment Date</th>
                      <th>Payment Mode</th>
                      <th>Payment Snapshot</th>
                      <th>Payment Confirmation</th>
                      <th>Accounts-Payment Remark</th>
                      <th style={{ minWidth: "100px" }}>
                        Payment Confirmation Date
                      </th>
                      <th>Sample Design Ready</th>
                      <th>Approval by Partner</th>
                      <th>Print File</th>
                      <th>Print Status</th>
                      <th style={{ minWidth: "100px" }}>Print File Date</th>
                      <th>Print Remarks</th>
                      <th>Sleeve Handover to Warehouse</th>
                      <th style={{ minWidth: "100px" }}>
                        Sleeve Handover Date
                      </th>
                      <th>Sleeve Receive to Warehouse</th>
                      <th style={{ minWidth: "100px" }}>
                        Sleeve Receive to Date
                      </th>
                      <th>Dispatch</th>
                      <th>Delivery</th>
                      <th>Redispatch</th>
                      {/* <th>Status</th>
                  <th>Image</th>
                  <th>Date</th>
                  <th>Add File</th>
                  <th>Actions</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {orders.map((o) => {
                      const hasClientDetails =
                        (Array.isArray(o?.clients) && o.clients.length > 0) ||
                        (o?.clients &&
                          typeof o.clients === "object" &&
                          Object.keys(o.clients).length > 0) ||
                        (typeof o?.clients === "string" &&
                          o.clients.trim().length > 0) ||
                        o?.total_clients > 0 ||
                        o?.client_count > 0;

                      const canPrint = isSuperAdmin
                        ? hasClientDetails
                        : isPaymentReceived(o?.payment_status) &&
                          !!o?.payment_confirmed &&
                          hasClientDetails &&
                          !!o?.is_sample_design_ready &&
                          !!o?.is_approved_by_partner;

                      // const canPrint =
                      // isPaymentReceived(o?.payment_status) &&
                      // !!o?.payment_confirmed &&
                      // hasClientDetails &&
                      // !!o?.is_sample_design_ready &&
                      // !!o?.is_approved_by_partner;

                      const reasons = getMissingReasons(o, hasClientDetails);

                      // const totalClients = Array.isArray(o?.clients)
                      //   ? o.clients.length
                      //   : o?.total_clients ?? o?.client_count ?? 0;

                      const totalClients =
                        o?.total_clients ?? o?.client_count ?? 0;

                      const dispatched =
                        o?.total_dispatches ?? o?.dispatch_count ?? 0;

                      const delivered =
                        o?.total_delivered ?? o?.delivered_count ?? 0;

                      const redispatched =
                        o?.total_redispatches ?? o?.redispatch_count ?? 0;

                      const inputId = `client-details-file-${o.id}`;
                      return (
                        <tr key={o.id}>
                          <td>{o.order_no ?? o.orderNumber}</td>
                          <td>
                            {(() => {
                              const raw = o.created_at;
                              if (!raw) return "—";
                              const dt = new Date(raw);
                              if (isNaN(+dt)) return "—";

                              const dateStr = dt.toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              });

                              const timeStr = dt.toLocaleTimeString("en-GB", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              });

                              return (
                                <div className="d-flex flex-column lh-sm gap-1">
                                  <strong>{dateStr}</strong>
                                  <p className="m-0">{timeStr}</p>
                                </div>
                              );
                            })()}
                          </td>

                          <td>
                            {new Intl.NumberFormat("en-IN", {
                              style: "currency",
                              currency: "INR",
                              minimumFractionDigits: 0,
                            }).format(o.order_amount)}
                          </td>
                          <td>
                            {/* {new Date(o.order_date).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              }
                            )} */}
                            <div className="d-flex flex-column lh-sm gap-1">
                              <strong>
                                {new Date(o.order_date).toLocaleString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  }
                                )}
                              </strong>
                              {/* <p className="m-0">
                                {new Date(o.order_date).toLocaleString(
                                  "en-GB",
                                  {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  }
                                )}
                              </p> */}
                            </div>
                          </td>
                          <td>{o?.partner?.partner_code}</td>
                          <td>{o?.partner?.name ?? o.customer}</td>
                          <td>{o?.with_sleeve.toUpperCase()}</td>
                          <td>
                            <div className="d-flex flex-column gap-0 lh-sm">
                              <strong>{o?.partner?.company_name}</strong>
                              {o?.partner?.mobile_number}
                              <a href={`mailto:${o?.partner?.email}`}>
                                {o?.partner?.email}
                              </a>
                            </div>
                          </td>
                          <td>{o?.with_client_name ? "WITH" : "WITHOUT"}</td>
                          <td>{o?.sleeve?.sleeve_type}</td>
                          <td>{o?.sleeve?.sleeve_name}</td>
                          <td>{o?.occassion_month ?? "-"}</td>
                          <td>{o?.qty ?? "-"}</td>
                          <td>{o?.partner_address_delivery_qty ?? "-"}</td>
                          <td>{o?.client_address_delivery_qty ?? "-"}</td>
                          <td>{o?.creator?.name ?? "-"}</td>
                          <td>
                            {hasClientDetails ? (
                              <div className="d-flex align-items-center gap-2">
                                <Badge
                                  bg="success"
                                  className="cursor-pointer"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    openClientList(o);
                                  }}
                                >
                                  {o?.clients?.length}
                                </Badge>
                                {/* <Button
                                  size="sm"
                                  variant="outline-primary"
                                  className="upload-btn"
                                  // onClick={() =>
                                  //   document.getElementById(inputId)?.click()
                                  // }
                                  disabled={!canUploadClient}
                                  title={
                                    !canUploadClient ? "No permission" : ""
                                  }
                                  onClick={() =>
                                    canUploadClient &&
                                    document.getElementById(inputId)?.click()
                                  }
                                >
                                  Reupload
                                </Button>
                              </div>
                            ) : (
                              <Button
                                size="sm"
                                variant="outline-secondary"
                                // onClick={() =>
                                //   document.getElementById(inputId)?.click()
                                // }
                                className="upload-btn"
                                disabled={!canUploadClient}
                                title={!canUploadClient ? "No permission" : ""}
                                onClick={() =>
                                  canUploadClient &&
                                  document.getElementById(inputId)?.click()
                                }
                              >
                                Upload Client Details
                              </Button> */}
                                <Button
                                  size="sm"
                                  variant="outline-primary"
                                  className="upload-btn"
                                  disabled={!canUploadClient || o.isUploading}
                                  title={
                                    !canUploadClient ? "No permission" : ""
                                  }
                                  onClick={() =>
                                    canUploadClient &&
                                    document.getElementById(inputId)?.click()
                                  }
                                >
                                  {o.isUploading ? (
                                    <Loader text="Reuploading..." />
                                  ) : (
                                    "Reupload"
                                  )}
                                </Button>
                              </div>
                            ) : (
                              <Button
                                size="sm"
                                variant="outline-secondary"
                                className="upload-btn"
                                disabled={!canUploadClient || o.isUploading}
                                title={!canUploadClient ? "No permission" : ""}
                                onClick={() =>
                                  canUploadClient &&
                                  document.getElementById(inputId)?.click()
                                }
                              >
                                {o.isUploading ? (
                                  <Loader text="Uploading..." />
                                ) : (
                                  "Upload Client Details"
                                )}
                              </Button>
                            )}
                            {/* hidden file input per row */}
                            <Form.Control
                              id={inputId}
                              type="file"
                              accept=".xls,.xlsx,.csv"
                              className="d-none"
                              onChange={async (e) => {
                                if (!canUploadClient) return;
                                const file = e.target.files?.[0];
                                await handleClientDetailsUpload(o, file);
                                e.target.value = ""; // reset after upload
                              }}
                            />

                            {/* hidden file input per row */}
                            {/* <Form.Control
                              id={inputId}
                              type="file"
                              accept=".xls,.xlsx,.csv"
                              className="d-none"
                              // onChange={async (e) => {
                              //   const file = e.target.files?.[0];
                              //   await handleClientDetailsUpload(o, file);
                              //   e.target.value = ""; // reset after upload
                              // }}
                              // onChange={(e) => canUploadClient && handleClientDetailsUpload(o, e.target.files?.[0])}
                              onChange={async (e) => {
                                if (!canUploadClient) return;
                                const file = e.target.files?.[0];
                                await handleClientDetailsUpload(o, file);
                                e.target.value = ""; // reset after upload
                              }}
                            /> */}
                          </td>
                          <td>
                            {o?.client_details_received_date ? (
                              <div className="d-flex flex-column lh-sm gap-1">
                                <strong>
                                  {new Date(
                                    o?.client_details_received_date
                                  ).toLocaleString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  })}
                                </strong>
                                <p className="m-0">
                                  {new Date(
                                    o?.client_details_received_date
                                  ).toLocaleString("en-GB", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })}
                                </p>
                              </div>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="dropdown-td">
                            {/* Per-row status dropdown (display only; wire onSelect to update if needed) */}
                            <Dropdown>
                              <Dropdown.Toggle
                                variant={
                                  getPaymentVariant?.(o.payment_status) ||
                                  getStatusVariant(o.payment_status)
                                }
                                id={`payment-status-dd-${o.id}`}
                                size="sm"
                              >
                                {o.payment_status ?? "Pending"}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  onClick={() =>
                                    handlePaymentStatusChange(o, "Pending")
                                  }
                                >
                                  Pending
                                </Dropdown.Item>
                                <Dropdown.Item
                                  // onClick={() =>
                                  //   handlePaymentStatusChange(o, "Received")
                                  // }
                                  disabled={!canMarkPaymentReceived}
                                  title={
                                    !canMarkPaymentReceived
                                      ? "No permission"
                                      : ""
                                  }
                                  onClick={() =>
                                    canMarkPaymentReceived &&
                                    handlePaymentStatusChange(o, "Received")
                                  }
                                >
                                  Recieved
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                          <td>
                            {o?.payment_received_date ? (
                              <div className="d-flex flex-column lh-sm gap-1">
                                <strong>
                                  {new Date(
                                    o?.payment_received_date
                                  ).toLocaleString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  })}
                                </strong>
                                <p className="m-0">
                                  {new Date(
                                    o?.payment_received_date
                                  ).toLocaleString("en-GB", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })}
                                </p>
                              </div>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>{o?.payment_mode ?? "-"}</td>
                          <td>
                            {o?.payment_snapshots &&
                            o?.payment_snapshots?.url ? (
                              // <a
                              //   href={`${process.env.REACT_APP_API_URL}/${o.payment_snapshots}`}
                              //   target="_blank"
                              //   rel="noreferrer"
                              // >
                              //   <img
                              //     src={`${process.env.REACT_APP_API_URL}/${o.payment_snapshots}`}
                              //     alt="payment snapshot"
                              //     style={{
                              //       width: 44,
                              //       height: 44,
                              //       objectFit: "cover",
                              //       borderRadius: 6,
                              //       border: "1px solid #e5e7eb",
                              //     }}
                              //   />
                              // </a>
                              <button
                                className="border-none p-0 "
                                onClick={() =>
                                  setImageModal({
                                    open: true,
                                    image: o?.payment_snapshots?.url,
                                    // image: `${apiURL}/${o.payment_snapshots}`,
                                    alt: "payment snapshot",
                                  })
                                }
                              >
                                <Image
                                  src={o?.payment_snapshots?.url}
                                  alt="payment snapshot"
                                  width={44}
                                  height={44}
                                  className="rounded-2"
                                />
                              </button>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="dropdown-td">
                            <Dropdown>
                              <Dropdown.Toggle
                                variant={
                                  o.payment_confirmed ? "success" : "warning"
                                }
                                id={`payment-confirmed-dd-${o.id}`}
                                size="sm"
                                disabled={!canConfirmPayment}
                                title={
                                  !canConfirmPayment ? "No permission" : ""
                                }
                              >
                                {o.payment_confirmed ? "Confirmed" : "Pending"}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  // onClick={() =>
                                  //   handlePaymentConfirmedChange(o, "Pending")
                                  // }
                                  disabled={!canConfirmPayment}
                                  onClick={() =>
                                    canConfirmPayment &&
                                    handlePaymentConfirmedChange(o, "Pending")
                                  }
                                >
                                  Pending
                                </Dropdown.Item>
                                <Dropdown.Item
                                  // onClick={() =>
                                  //   handlePaymentConfirmedChange(o, "Confirmed")
                                  // }
                                  disabled={!canConfirmPayment}
                                  onClick={() =>
                                    canConfirmPayment &&
                                    handlePaymentConfirmedChange(o, "Confirmed")
                                  }
                                >
                                  Confirmed
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                          <td>{o?.account_payment_remarks ?? "-"}</td>
                          <td>
                            {o?.payment_confirmation_date ? (
                              <div className="d-flex flex-column lh-sm gap-1">
                                <strong>
                                  {new Date(
                                    o?.payment_confirmation_date
                                  ).toLocaleString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  })}
                                </strong>
                                <p className="m-0">
                                  {new Date(
                                    o?.payment_confirmation_date
                                  ).toLocaleString("en-GB", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })}
                                </p>
                              </div>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="dropdown-td">
                            <Dropdown>
                              <Dropdown.Toggle
                                variant={getYesNoVariant(
                                  o.is_sample_design_ready
                                )}
                                id={`sample-ready-dd-${o.id}`}
                                size="sm"
                                disabled={!canSampleDesign}
                              >
                                {o.is_sample_design_ready ? "YES" : "NO"}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  // onClick={() =>
                                  //   handleSampleDesignReadyChange(o, true)
                                  // }
                                  disabled={!canSampleDesign}
                                  onClick={() =>
                                    canSampleDesign &&
                                    handleSampleDesignReadyChange(o, true)
                                  }
                                >
                                  YES
                                </Dropdown.Item>
                                <Dropdown.Item
                                  // onClick={() =>
                                  //   handleSampleDesignReadyChange(o, false)
                                  // }
                                  disabled={!canSampleDesign}
                                  onClick={() =>
                                    canSampleDesign &&
                                    handleSampleDesignReadyChange(o, false)
                                  }
                                >
                                  NO
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                          <td className="dropdown-td">
                            <Dropdown>
                              <Dropdown.Toggle
                                variant={getYesNoVariant(
                                  o.is_approved_by_partner
                                )}
                                id={`approved-by-partner-dd-${o.id}`}
                                size="sm"
                                disabled={!canPartnerApprove}
                              >
                                {o.is_approved_by_partner ? "YES" : "NO"}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  // onClick={() =>
                                  //   handleApprovedByPartnerChange(o, true)
                                  // }
                                  disabled={!canPartnerApprove}
                                  onClick={() =>
                                    canPartnerApprove &&
                                    handleApprovedByPartnerChange(o, true)
                                  }
                                >
                                  YES
                                </Dropdown.Item>
                                <Dropdown.Item
                                  // onClick={() =>
                                  //   handleApprovedByPartnerChange(o, false)
                                  // }
                                  disabled={!canPartnerApprove}
                                  onClick={() =>
                                    canPartnerApprove &&
                                    handleApprovedByPartnerChange(o, false)
                                  }
                                >
                                  NO
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                          {/* <td>
                            {canPrint ? (
                              <Button
                                size="sm"
                                variant="primary"
                                onClick={() => handleDownloadPrintFile(o)}
                                disabled={downloadingId === o.id}
                                className="download-btn"
                              >
                                {downloadingId === o.id
                                  ? "Downloading..."
                                  : "Download"}
                              </Button>
                            ) : (
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <BsTooltip id={`tt-print-disabled-${o.id}`}>
                                    <div className="text-start">
                                      <div className="fw-semibold mb-1">
                                        Cannot download yet:
                                      </div>
                                      <ul className="mb-0 ps-3">
                                        {reasons.map((r) => (
                                          <li key={r}>{r}</li>
                                        ))}
                                      </ul>
                                    </div>
                                  </BsTooltip>
                                }
                              >
                                // {/* wrap disabled button in span so tooltip works */}
                          {/* <span className="d-inline-block">
                                  <Button
                                    size="sm"
                                    variant="secondary"
                                    disabled
                                    className="pointer-none download-btn"
                                  >
                                    Download
                                  </Button>
                                </span>
                              </OverlayTrigger> */}
                          {/* )} */}
                          {/* <Button
                          size="sm"
                          variant="primary"
                          disabled={
                            !(
                              canGeneratePrint &&
                              isEligibleForPrint(o, hasClientDetails)
                            )
                          }
                          title={
                            !canGeneratePrint
                              ? "No permission"
                              : !isEligibleForPrint(o, hasClientDetails)
                              ? "Missing prerequisites"
                              : "Download"
                          }
                          onClick={() =>
                            canGeneratePrint &&
                            isEligibleForPrint(o, hasClientDetails) &&
                            handleDownloadPrintFile(o)
                          }
                        >
                          Download
                        </Button> */}
                          {/* </td> */}

                          {/* new downloading loader code */}

                          <td>
                            {canPrint ? (
                              <Button
                                size="sm"
                                variant="primary"
                                onClick={async () => {
                                  // loader start (add id)
                                  setDownloadingIds((prev) =>
                                    new Set(prev).add(o.id)
                                  );

                                  await handleDownloadPrintFile(o);

                                  // loader stop (remove id)
                                  setDownloadingIds((prev) => {
                                    const updated = new Set(prev);
                                    updated.delete(o.id);
                                    return updated;
                                  });
                                }}
                                disabled={downloadingIds.has(o.id)}
                                className="download-btn"
                              >
                                {downloadingIds.has(o.id) ? (
                                  <>
                                    <span
                                      className="spinner-border spinner-border-sm me-2"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    Downloading...
                                  </>
                                ) : (
                                  "Download"
                                )}
                              </Button>
                            ) : (
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <BsTooltip id={`tt-print-disabled-${o.id}`}>
                                    <div className="text-start">
                                      <div className="fw-semibold mb-1">
                                        Cannot download yet:
                                      </div>
                                      <ul className="mb-0 ps-3">
                                        {reasons.map((r) => (
                                          <li key={r}>{r}</li>
                                        ))}
                                      </ul>
                                    </div>
                                  </BsTooltip>
                                }
                              >
                                <span className="d-inline-block">
                                  <Button
                                    size="sm"
                                    variant="secondary"
                                    disabled
                                    className="pointer-none download-btn"
                                  >
                                    Download
                                  </Button>
                                </span>
                              </OverlayTrigger>
                            )}
                          </td>

                          <td className="dropdown-td">
                            <Dropdown>
                              <Dropdown.Toggle
                                variant={getPrintVariant(o.print_status)}
                                id={`print-status-dd-${o.id}`}
                                size="sm"
                                disabled={!canUpdatePrint}
                              >
                                {o.print_status ?? "Pending"}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  // onClick={() =>
                                  //   handlePrintStatusChange(o, "Pending")
                                  // }
                                  disabled={!canUpdatePrint}
                                  onClick={() =>
                                    canUpdatePrint &&
                                    handlePrintStatusChange(o, "Pending")
                                  }
                                >
                                  Pending
                                </Dropdown.Item>
                                <Dropdown.Item
                                  // onClick={() => handlePrintStatusChange(o, "Done")}
                                  disabled={!canUpdatePrint}
                                  onClick={() =>
                                    canUpdatePrint &&
                                    handlePrintStatusChange(o, "Done")
                                  }
                                >
                                  Done
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                          <td>
                            {o?.print_file_date ? (
                              <div className="d-flex flex-column lh-sm gap-1">
                                <strong>
                                  {new Date(o?.print_file_date).toLocaleString(
                                    "en-GB",
                                    {
                                      day: "2-digit",
                                      month: "2-digit",
                                      year: "numeric",
                                    }
                                  )}
                                </strong>
                                <p className="m-0">
                                  {new Date(o?.print_file_date).toLocaleString(
                                    "en-GB",
                                    {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    }
                                  )}
                                </p>
                              </div>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>{o?.print_remarks ?? "-"}</td>
                          <td className="dropdown-td">
                            <Dropdown>
                              <Dropdown.Toggle
                                variant={getPendingSentVariant(
                                  o.is_sleeve_handover_to_warehouse
                                    ? "Sent"
                                    : "Pending"
                                )}
                                id={`handover-warehouse-dd-${o.id}`}
                                size="sm"
                                disabled={!canWHhandover}
                              >
                                {o.is_sleeve_handover_to_warehouse
                                  ? "Sent"
                                  : "Pending"}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  // onClick={() =>
                                  //   handleSleeveHandoverChange(o, "Pending")
                                  // }
                                  disabled={!canWHhandover}
                                  onClick={() =>
                                    canWHhandover &&
                                    handleSleeveHandoverChange(o, "Pending")
                                  }
                                >
                                  Pending
                                </Dropdown.Item>
                                <Dropdown.Item
                                  // onClick={() =>
                                  //   handleSleeveHandoverChange(o, "Sent")
                                  // }
                                  disabled={!canWHhandover}
                                  onClick={() =>
                                    canWHhandover &&
                                    handleSleeveHandoverChange(o, "Sent")
                                  }
                                >
                                  Sent
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                          <td>
                            {o?.sleeve_handover_date ? (
                              <div className="d-flex flex-column lh-sm gap-1">
                                <strong>
                                  {new Date(
                                    o?.sleeve_handover_date
                                  ).toLocaleString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  })}
                                </strong>
                                <p className="m-0">
                                  {new Date(
                                    o?.sleeve_handover_date
                                  ).toLocaleString("en-GB", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })}
                                </p>
                              </div>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="dropdown-td">
                            <Dropdown>
                              <Dropdown.Toggle
                                variant={getPendingReceivedVariant(
                                  o.is_sleeve_received_to_warehouse
                                    ? "Received"
                                    : "Pending"
                                )}
                                id={`sleeve-received-warehouse-dd-${o.id}`}
                                size="sm"
                                disabled={!canWHreceive}
                              >
                                {o.is_sleeve_received_to_warehouse
                                  ? "Received"
                                  : "Pending"}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  // onClick={() =>
                                  //   handleSleeveReceivedChange(o, "Pending")
                                  // }
                                  disabled={!canWHreceive}
                                  onClick={() =>
                                    canWHreceive &&
                                    handleSleeveReceivedChange(o, "Pending")
                                  }
                                >
                                  Pending
                                </Dropdown.Item>
                                <Dropdown.Item
                                  // onClick={() =>
                                  //   handleSleeveReceivedChange(o, "Received")
                                  // }
                                  disabled={!canWHreceive}
                                  onClick={() =>
                                    canWHreceive &&
                                    handleSleeveReceivedChange(o, "Received")
                                  }
                                >
                                  Received
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                          <td>
                            {o?.sleeve_received_date ? (
                              <div className="d-flex flex-column lh-sm gap-1">
                                <strong>
                                  {new Date(
                                    o?.sleeve_received_date
                                  ).toLocaleString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  })}
                                </strong>
                                <p className="m-0">
                                  {new Date(
                                    o?.sleeve_received_date
                                  ).toLocaleString("en-GB", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })}
                                </p>
                              </div>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>
                            <Button
                              size="sm"
                              variant={
                                totalClients > 0 && dispatched >= totalClients
                                  ? "success"
                                  : "info"
                              }
                              className="dispatch-btn"
                              onClick={() => openDispatchModal(o)}
                              title="View dispatches"
                            >
                              {dispatched}/{totalClients}
                            </Button>
                          </td>
                          <td>
                            <Button
                              size="sm"
                              variant={
                                totalClients > 0 && delivered >= totalClients
                                  ? "success"
                                  : "info"
                              }
                              className="dispatch-btn"
                              onClick={() => openDeliveryModal(o)}
                              title="View deliveries"
                            >
                              {delivered}/{totalClients}
                            </Button>
                          </td>
                          <td>
                            <Button
                              size="sm"
                              className="dispatch-btn"
                              variant={
                                totalClients > 0 && redispatched >= totalClients
                                  ? "success"
                                  : "info"
                              }
                              onClick={() => openRedispatchModal(o)}
                              title="View redispatches"
                            >
                              {redispatched}/{totalClients}
                            </Button>
                          </td>
                          {/* <td className="dropdown-td">
                        <Dropdown>
                          <Dropdown.Toggle
                            variant={getStatusVariant(o.status)}
                            id={`status-dd-${o.id}`}
                            size="sm"
                          >
                            {o.status ?? "Pending"}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                            >
                              Pending
                            </Dropdown.Item>
                            <Dropdown.Item
                            >
                              Processing
                            </Dropdown.Item>
                            <Dropdown.Item
                            >
                              Completed
                            </Dropdown.Item>
                            <Dropdown.Item
                            >
                              Cancelled
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>

                      <td>
                        <Image
                          src={
                            o.image_url ||
                            "https://staging.harsonexim.com/images/blog/blogs/blog-home.webp"
                          }
                          alt="image"
                          className="table-image"
                        />
                      </td>
                      <td>{o.date}</td>
                      <td className="file-select-input">
                        <Form.Group controlId={`file-${o.id}`}>
                          <Form.Control type="file" size="sm" />
                        </Form.Group>
                      </td>
                      <td>
                        <div className="d-flex">
                          <Button
                            size="sm"
                            className="table-btn me-2"
                            title="View"
                            onClick={() => onView(o)}
                          >
                            <MdVisibility />
                          </Button>
                          <Button
                            size="sm"
                            className="table-btn me-2"
                            title="Edit"
                            onClick={() => onEdit(o)}
                          >
                            <MdEdit />
                          </Button>
                          <Button
                            size="sm"
                            className="table-btn"
                            title="Delete"
                            onClick={() => onDelete(o)}
                          >
                            <MdDelete />
                          </Button>
                        </div>
                      </td> */}
                        </tr>
                      );
                    })}
                    {orders.length === 0 && !loading && (
                      <tr>
                        <td colSpan={9} className="text-center text-muted">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
              <CustomPagination
                currentPage={currentPage}
                totalPages={totalPages}
                loading={loading}
                onPageChange={(page) => {
                  setCurrentPage(page);
                  fetchOrdersWithFilters({ page, limit: pageSize });
                }}
                className={""}
                pageSize={pageSize}
                setPageSize={(limit) => {
                  setPageSize(limit);
                  setCurrentPage(1);
                  fetchOrdersWithFilters({ page: 1, limit });
                }}
                setCurrentPage={setCurrentPage}
                total={total}
                perPageOptions={BIG_PAGE_OPTIONS}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="profile">Second tab content</Tab.Pane>
            <Tab.Pane eventKey="contact">Second tab content</Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
      {/* </div> */}

      {/* orders main Modal */}
      <OrdersMainModal
        show={showImport}
        onHide={() => {
          setShowImport(false);
          setImportReport(null);
          setImportSuccess(null);
        }}
        onSubmit={() => {}}
        importSuccess={importSuccess}
        setPayModalData={setPayModalData}
        importReport={importReport}
        uploading={uploading}
        onImportFileChange={onImportFileChange}
        downloadValidationErrorsCsv={downloadValidationErrorsCsv}
        setShowImport={setShowImport}
        setImportReport={setImportReport}
        setImportSuccess={setImportSuccess}
      />
      <OrdersMainModal
        show={showDispatchImport}
        onHide={() => {
          setShowDispatchImport(false);
          setDispatchReport(null);
          setDispatchSuccess(null);
        }}
        // make it look specific to dispatch:
        title="Upload Dispatch Data"
        accept=".xlsx,.xls,.csv"
        importSuccess={dispatchSuccess}
        importReport={dispatchReport}
        uploading={dispatchUploading}
        onImportFileChange={onDispatchFileChange}
        downloadValidationErrorsCsv={() =>
          downloadValidationErrorsCsv(dispatchReport)
        }
        // the following setters are used by the footer “Upload another / Done”
        setShowImport={setShowDispatchImport}
        setImportReport={setDispatchReport}
        setImportSuccess={setDispatchSuccess}
      />

      <OrdersMainModal
        // onHide={() => {
        //   setShowDeliveryImport(false);
        //   setDeliveryImportReport(null);
        //   setDeliveryImportSuccess(null);
        //   setDeliveryImportOrder(null);
        // }}
        // importSuccess={deliveryImportSuccess}
        // importReport={deliveryImportReport}
        // uploading={deliveryUploading}
        // onImportFileChange={onDeliveryImportFileChange}
        // downloadValidationErrorsCsv={downloadValidationErrorsCsv} // reuse your existing util
        // setShowImport={setShowDeliveryImport}
        // setImportReport={setDeliveryImportReport}
        // setImportSuccess={setDeliveryImportSuccess}
        show={showDeliveryImport}
        onHide={() => {
          setShowDeliveryImport(false);
          setDeliveryImportReport(null);
          setDeliveryImportSuccess(null);
        }}
        // make it look specific to dispatch:
        title={`Upload Delivery Data`}
        accept=".xlsx,.xls,.csv"
        importSuccess={deliveryImportSuccess}
        importReport={deliveryImportReport}
        uploading={deliveryUploading}
        onImportFileChange={onDeliveryImportFileChange}
        downloadValidationErrorsCsv={() =>
          downloadValidationErrorsCsv(deliveryImportReport)
        }
        // the following setters are used by the footer “Upload another / Done”
        setShowImport={setShowDeliveryImport}
        setImportReport={setDeliveryImportReport}
        setImportSuccess={setDeliveryImportSuccess}
      />

      <OrdersMainModal
        show={showRedispatchImport}
        onHide={() => {
          setShowRedispatchImport(false);
          setRedispatchImportReport(null);
          setRedispatchImportSuccess(null);
        }}
        title="Upload Redispatch Data"
        accept=".xlsx,.xls,.csv"
        importSuccess={redispatchImportSuccess}
        importReport={redispatchImportReport}
        uploading={redispatchUploading}
        onImportFileChange={onRedispatchImportFileChange}
        downloadValidationErrorsCsv={() =>
          downloadValidationErrorsCsv(redispatchImportReport)
        }
        setShowImport={setShowRedispatchImport}
        setImportReport={setRedispatchImportReport}
        setImportSuccess={setRedispatchImportSuccess}
      />

      {/* payment modal */}
      <PaymentModal
        show={showPayModal}
        onHide={closePaymentModal}
        onSubmit={submitPaymentModal}
        payModalData={payModalData}
        setPayModalData={setPayModalData}
      />
      {/* confirm payment modal */}
      <ConfirmPayment
        show={showPaymentConfirmedModal}
        onHide={closePaymentConfirmedModal}
        onSubmit={submitPaymentConfirmed}
        remark={remark}
        setRemark={setRemark}
      />

      {/* print modal */}
      <PrintModal
        show={showPrintModal}
        onHide={closePrintModal}
        printModal={printModal}
        setPrintModal={setPrintModal}
        submitPrintModal={submitPrintModal}
      />

      <DispatchListModal
        show={showDispatchModal}
        onHide={closeDispatchModal}
        order={dispatchOrder}
        loading={dispatchLoading}
        list={dispatchList}
        page={dispatchPage}
        totalPages={dispatchTotalPages}
        total={dispatchTotal}
        pageSize={dispatchPageSize}
        onPageChange={handleDispatchPageChange}
      />

      <DeliveryListModal
        show={showDeliveryModal}
        onHide={closeDeliveryModal}
        order={deliveryOrder}
        loading={deliveryLoading}
        list={deliveryList}
        page={deliveryPage}
        totalPages={deliveryTotalPages}
        total={deliveryTotal}
        pageSize={deliveryPageSize}
        onPageChange={handleDeliveryPageChange}
      />

      <RedispatchListModal
        show={showRedispatchModal}
        onHide={closeRedispatchModal}
        order={redispatchOrder}
        loading={redispatchLoading}
        list={redispatchList}
        page={redispatchPage}
        totalPages={redispatchTotalPages}
        total={redispatchTotal}
        pageSize={redispatchPageSize}
        onPageChange={handleRedispatchPageChange}
      />
      <ImageModal
        show={imageModal?.open}
        onHide={() => {
          setImageModal({ open: false, image: "", alt: "" });
        }}
        image={imageModal?.image}
        alt={imageModal?.alt}
      />
      <ClientListModal
        show={showClientListModal}
        onHide={closeClientListModal}
        list={clientList}
        order={clientOrder}
      />
      <FilterModal
        show={filterModalOpen}
        onHide={() => setFilterModalOpen(false)}
        initialFilters={filters}
        onApply={handleFiltersApply}
      />
    </>
  );
};

export default Orders;
